import { render, staticRenderFns } from "./StaticRewardsCart.vue?vue&type=template&id=0136fca0&scoped=true&"
import script from "./StaticRewardsCart.vue?vue&type=script&lang=js&"
export * from "./StaticRewardsCart.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&lang=css&"
import style1 from "./StaticRewardsCart.vue?vue&type=style&index=1&id=0136fca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0136fca0",
  null
  
)

export default component.exports